function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 24 24"
}, props), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18c0-1.1-.89-2-1.99-2zm-3 9h-2V9h2v2zm-6 0h2V9h-2v2zm-2 0H7V9h2v2z",
  fill: "#666"
})));